import styled from 'styled-components'

export const Container = styled.div`
	width: 100%;
	height: 84px;
	position: fixed;
	top: 0;
	z-index: 1200;
	display: flex;
	align-items: center;
	background: #fff;

	box-shadow: rgba(0, 0, 0, 0.08) 0px 2px 6px 0px, rgba(0, 0, 0, 0.12) 0px 0px 1px 0px;
`

export const Content = styled.div`
	width: 100%;
	max-width: 1440px;
	margin: 0 auto;
	display: flex;
	align-items: center;
	padding-left: 40px;
`

export const PartnerContainer = styled.div`
	height: 55px;
	display: flex;
	align-items: center;
	width: 100%;
`

export const PartnerImg = styled.img`
	object-fit: contain;
	max-width: 100%;
	max-height: 100%;
	width: auto;
	height: auto;
	margin-left: -8px;
`

export const ImgLogo = styled.div`
	cursor: pointer;
	width: 115px;

	@media(max-width: 767px) {
		width: 110px;
	}
`
